export default "__VITE_ASSET__BeepL4x1__"